import { ProductBudgetUse } from '@frontend/budget/types';
import { DefaultSecondaryButton } from '@frontend/components/common';
import { IProduct } from '@frontend/product/types';
import { FormattedMessage } from 'react-intl';

import { KioskList } from '../../../components/kiosk-list.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import { useRecycleOverview } from './recycle-overview.controller';

const ID = 'recycle-overview';

export const RecycleOverview = () => {
    const viewProps = useRecycleOverview();

    return (
        <WizardScreenContainer
            id={ID}
            loadingModal={{
                show: viewProps.isLoading || viewProps.isProcessing,
                onClose: () => viewProps.setIsLoading(false)
            }}
            errorModal={{
                show: !!viewProps.error,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            containerClassName='flex size-full flex-col overflow-x-hidden overflow-y-auto p-6 gap-3'
            footer={{
                submitLabel: (
                    <FormattedMessage
                        id='kiosk.wizard.recycle-overview.recycle-product'
                        defaultMessage='Recycle product'
                    />
                ),
                submitDisabled: !viewProps.selectedProduct || viewProps.isProcessing,
                onSubmit: viewProps.onRecycle
            }}>
            <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                <KioskList<ProductBudgetUse>
                    id='recycle-overview'
                    fetch={viewProps.fetchBudgetUses}
                    rowElement={(budgetUse) => (
                        <ProductCard
                            key={budgetUse.id}
                            product={{ ...budgetUse, account_id: viewProps.accountId } as IProduct}
                            onClick={(obj) => viewProps.setSelectedProduct(viewProps.selectedProduct === obj.id ? null : obj.id)}
                            variant='attributes'
                            styles={{
                                container: viewProps.selectedProduct === budgetUse.id ? '!border-brand-primary border-2' : ''
                            }}
                        />
                    )}
                    emptyText={
                        <div className='flex flex-col items-center justify-center gap-3'>
                            <span className='text-foreground-secondary text-lg font-medium'>
                                <FormattedMessage
                                    id='kiosk.wizard.recycle-overview.no-products'
                                    defaultMessage='No products to recycle'
                                />
                            </span>
                        </div>
                    }
                />
                {viewProps.hasOtherRecycle && (
                    <div className='flex w-full justify-end'>
                        <DefaultSecondaryButton
                            text={
                                <FormattedMessage
                                    id='kiosk.wizard.recycle-overview.other'
                                    defaultMessage='Other'
                                />
                            }
                            onClick={viewProps.onOtherRecycle}
                            disabled={viewProps.isProcessing}
                        />
                    </div>
                )}
            </div>
        </WizardScreenContainer>
    );
};

export default RecycleOverview;
